import Computer from 'mbs-ui-shared@models/Computer';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { NotificationSettings, WindowsEventLogNotificationSettings } from '../notifications-models';
import { Actions } from './base-models/plan-actions-model';
import { DeletePlan } from './base-models/plan-restore-delete-plan-model';
import { ScheduleSettingsModels } from './schedule-settings-models';

export type CreateRVPlanParams = {
  sourceHid: string;
  destinationHid: string;
  destinationFolder?: string;
  path: string;
  planName: string;
  password?: string;
  externalUserId: string;
  runAfterSave: boolean;
  interactiveMode: boolean;
  checkTimeSeconds?: number;
  deletePlan?: DeletePlan;
  vmSettings: {
    isInstantRestore: boolean;
    VmName: string;
    numCpu: number;
    memoryInMb: number;
    minMemoryInMb?: number;
    maxMemoryInMb?: number;
    dynamicMemoryEnabled?: boolean;
    frameRateSeconds?: number;
    testType: string;
    machineHid?: string;

    vmUuid?: string;

    guestOsType?: string;
    overwrite?: boolean;
    generationIsV2?: boolean;
    host?: string;
    node?: string;
    storage?: string;
    powerOnAfterRestore?: boolean;
    network?: string | { model: string | number; bridge: string };
    loginPassword?: {
      login: string;
      password: string;
    };
  };
};

export type RestoreWizardSettings = {
  computer: Computer;
  targetComputerData?: TargetComputerData;
  isNBF: boolean;
  type: PlanTypes;
  sourceHid?: string;
  sourceUserId?: string;
  sessionId?: string;
  password?: string;
  initialFormData?: { [key: string]: unknown };
};

export type TargetComputerData = { userId?: string; hid: string; email: string; computerName: string; toComputer?: Computer };

export enum PlansWizardMode {
  forRMM = 0,
  forRD = 1
}
export class BasePlan {
  public GFSJobBackupSwitch: string;
  public TLogBackupSwitch: string;
  public Incremental0BackupSwitch: string;
  public DiffBackupSwitch: string;
  public RestartFailedSwitch: string;
  public FullParameterSwitch: string;
  public SavePlanInCloud: boolean;
  public Notification: NotificationSettings;
  public ForceMissedSchedule: boolean;
  public Schedule: ScheduleSettingsModels;
  public ExecuteNextPlan: boolean;
  public SyncBeforeRun: boolean;
  public ExecuteNextPlanOnlyIfSucces: boolean;
  public NextExectutionPlan: string;
  public WindowsEventLogNotification: WindowsEventLogNotificationSettings;
  public Actions: Actions;
  public ForceFullNextPlan: boolean;
  public ForwardIncremental: boolean;
  public EncryptionPassword: string;
  public ID: string;
  public SGAccountID: string;
  public Bucket: string;
  public ConnectionID: string;
  public Tag: string;
  public CreationDateUtc: Date;
  public UseEncryption: boolean;
  public Name: string;
}
